module.exports = __webpack_public_path__ + "img/search.5274ee21.svg";